import CustomSwitch from "../../../../components/CustomSwitch";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";

interface Props {
    barcodeInformationRef: any
    isSerialNoRequired: boolean
    setIsSerialNoRequired: React.Dispatch<React.SetStateAction<boolean>>
    isCompanyBarcodeRequired: boolean
    setIsCompanyBarcodeRequired: React.Dispatch<React.SetStateAction<boolean>>
    isKeylogxBarcodeRequired: boolean
    setIsKeylogxBarcodeRequired: React.Dispatch<React.SetStateAction<boolean>>
}

const BarcodeInformation = ({
    barcodeInformationRef,
    isSerialNoRequired,
    setIsSerialNoRequired,
    isCompanyBarcodeRequired,
    setIsCompanyBarcodeRequired,
    isKeylogxBarcodeRequired,
    setIsKeylogxBarcodeRequired
}: Props) => {
    return (
        <div className='containerPart' ref={barcodeInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Barkod Bilgileri</h4>

                    <div className="row">
                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Seri No Zorunlu</label>
                            <CustomSwitch isActive={isSerialNoRequired} setIsActive={setIsSerialNoRequired} />
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Firma Barkod Zorunlu</label>
                            <CustomSwitch isActive={isCompanyBarcodeRequired} setIsActive={setIsCompanyBarcodeRequired} />
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Keylogx Barkod Zorunlu</label>
                            <CustomSwitch isActive={isKeylogxBarcodeRequired} setIsActive={setIsKeylogxBarcodeRequired} />
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default BarcodeInformation;